import { useLocation, Link } from 'react-router-dom';
import language from '../../variables/language';

// Extensible on purpose - future settings-adjacent tools are just another
// entry, no structural change needed. Shared between /settings itself and
// every individual tool page (see each Index.jsx) so a user inside one tool
// can jump straight to another without detouring back through /settings.
const TOOLS = () => {
   const lang = language[language.lang];
   return [
      { to: '/background-health', title: lang.backgroundHealthPage.settingsLinkTitle, description: lang.backgroundHealthPage.settingsLinkDescription },
      { to: '/vocabulary-config', title: lang.vocabularyConfigPage.settingsLinkTitle, description: lang.vocabularyConfigPage.settingsLinkDescription },
      { to: '/ai-config', title: lang.aiConfigPage.settingsLinkTitle, description: lang.aiConfigPage.settingsLinkDescription },
      { to: '/quiz-generation-config', title: lang.quizGenerationConfigPage.settingsLinkTitle, description: lang.quizGenerationConfigPage.settingsLinkDescription },
      { to: '/db-backups', title: 'Резервні копії БД', description: 'Розклад, історія і логи копій бази даних' },
   ];
};

export default function SettingsToolbar() {
   const location = useLocation();
   const lang = language[language.lang];
   const tools = TOOLS();

   return (
      <div className='settings-toolbar'>
         <span className='settings-toolbar-title'>{lang.themeSettings.toolbarTitle}</span>
         <div className='settings-toolbar-links'>
            {tools.map((tool) => (
               <Link to={tool.to} key={tool.to} title={tool.description}
                  className={'settings-toolbar-link' + (location.pathname === tool.to ? ' active' : '')}>
                  {tool.title}
               </Link>
            ))}
         </div>
      </div>
   );
}
